module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("机侧题库")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("综合题库")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search mex-search"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题头 ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "题头主键，精确匹配"
    },
    model: {
      value: (_vm.queryParam.id),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "id", $$v)
      },
      expression: "queryParam.id"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "业务键"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 L1-L-U1-VR-Q001"
    },
    model: {
      value: (_vm.queryParam.businessCode),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "businessCode", $$v)
      },
      expression: "queryParam.businessCode"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "技能"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择技能"
    },
    on: {
      "on-change": _vm.loadQuestionTypes
    },
    model: {
      value: (_vm.queryParam.skill),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "skill", $$v)
      },
      expression: "queryParam.skill"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Listening"
    }
  }, [_vm._v("听力 Listening")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Reading"
    }
  }, [_vm._v("阅读 Reading")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Writing"
    }
  }, [_vm._v("写作 Writing")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "级别"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择级别"
    },
    model: {
      value: (_vm.queryParam.levelCode),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "levelCode", $$v)
      },
      expression: "queryParam.levelCode"
    }
  }, _vm._l((_vm.levels), function(lv) {
    return _c('Option', {
      key: lv,
      attrs: {
        "value": lv
      }
    }, [_vm._v(_vm._s(lv))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题型"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请选择题型"
    },
    model: {
      value: (_vm.queryParam.questionType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "questionType", $$v)
      },
      expression: "queryParam.questionType"
    }
  }, _vm._l((_vm.questionTypes), function(t) {
    return _c('Option', {
      key: t,
      attrs: {
        "value": t
      }
    }, [_vm._v(_vm._s(_vm.questionTypeLabel(t, _vm.queryParam.skill)))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.queryParam.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "status", $$v)
      },
      expression: "queryParam.status"
    }
  }, [_c('Option', {
    attrs: {
      "value": "PENDING_REVIEW"
    }
  }, [_vm._v("待审核 PENDING_REVIEW")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "ONLINE"
    }
  }, [_vm._v("已上线 ONLINE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "OFFLINE"
    }
  }, [_vm._v("已下线 OFFLINE")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DISCARDED"
    }
  }, [_vm._v("已废弃 DISCARDED")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "场景"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择场景"
    },
    model: {
      value: (_vm.queryParam.examScene),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "examScene", $$v)
      },
      expression: "queryParam.examScene"
    }
  }, [_c('Option', {
    attrs: {
      "value": "GENERAL"
    }
  }, [_vm._v("通用 GENERAL")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PLACEMENT_ONLY"
    }
  }, [_vm._v("仅入门测 PLACEMENT_ONLY")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE_ONLY"
    }
  }, [_vm._v("仅阶段测 SUMMATIVE_ONLY")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mex-search-actions"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.openBatch
    }
  }, [_vm._v("批量编辑")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.openCreate
    }
  }, [_vm._v("新建")]), _vm._v(" "), _c('Button', {
    on: {
      "click": function($event) {
        return _vm.triggerImport('Listening')
      }
    }
  }, [_vm._v("导入听力")]), _vm._v(" "), _c('Button', {
    on: {
      "click": function($event) {
        return _vm.triggerImport('Reading')
      }
    }
  }, [_vm._v("导入阅读")]), _vm._v(" "), _c('Button', {
    on: {
      "click": function($event) {
        return _vm.triggerImport('Writing')
      }
    }
  }, [_vm._v("导入写作")]), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.downloadTemplate
    }
  }, [_vm._v("下载模板")]), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.triggerIrt
    }
  }, [_vm._v("IRT 回填")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "info",
      "loading": _vm.inspectLoading
    },
    on: {
      "click": _vm.openBankInspect
    }
  }, [_vm._v("入门测题库自检")]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls,.xlsx"
    },
    on: {
      "change": _vm.importData
    }
  }), _vm._v(" "), _c('input', {
    ref: "irtInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xls,.xlsx"
    },
    on: {
      "change": _vm.importIrt
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "list",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/mex/comp/questions/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('MexQuestionBatchModal', {
    attrs: {
      "bank": "comp",
      "selected-rows": _vm.selection,
      "skill": _vm.queryParam.skill
    },
    on: {
      "success": _vm.search
    },
    model: {
      value: (_vm.batchVisible),
      callback: function($$v) {
        _vm.batchVisible = $$v
      },
      expression: "batchVisible"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "入门测题库自检",
      "width": "900",
      "mask-closable": false
    },
    model: {
      value: (_vm.inspectVisible),
      callback: function($$v) {
        _vm.inspectVisible = $$v
      },
      expression: "inspectVisible"
    }
  }, [(_vm.inspectReport) ? _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("\n      规则 " + _vm._s(_vm.inspectReport.ruleVersion || '—') + " / 校准 " + _vm._s(_vm.inspectReport.calibrationVersion || '—') + "\n      · 问题 " + _vm._s(_vm.inspectReport.issueCount || 0) + " 条\n      · " + _vm._s(_vm.inspectReport.ok ? '通过' : '未通过') + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.inspectRows.length) ? _c('Table', {
    attrs: {
      "columns": _vm.inspectColumns,
      "data": _vm.inspectRows,
      "size": "small",
      "max-height": "420"
    }
  }) : (_vm.inspectReport) ? _c('p', [_vm._v("未发现 BANK 问题")]) : _c('p', [_vm._v("加载中…")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.inspectVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.inspectLoading
    },
    on: {
      "click": _vm.openBankInspect
    }
  }, [_vm._v("重新自检")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑题目",
      "width": "960"
    },
    model: {
      value: (_vm.editVisible),
      callback: function($$v) {
        _vm.editVisible = $$v
      },
      expression: "editVisible"
    }
  }, [_c('p', [_vm._v("业务键 " + _vm._s(_vm.businessCode) + " / 版本 " + _vm._s(_vm.form.versionNo) + " / " + _vm._s(_vm.statusLabel(_vm.form.status))), (_vm.form.reviewer) ? _c('span', [_vm._v(" / 审核 " + _vm._s(_vm.form.reviewer))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "max-height": "70vh",
      "overflow-y": "auto",
      "padding-right": "8px"
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 130
    }
  }, [(_vm.createMode) ? _c('Form-item', {
    attrs: {
      "label": "业务键"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 L1-L-U1-VR-Q001"
    },
    model: {
      value: (_vm.businessCode),
      callback: function($$v) {
        _vm.businessCode = $$v
      },
      expression: "businessCode"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.createMode && _vm.versions.length) ? _c('Form-item', {
    attrs: {
      "label": "历史版本"
    }
  }, [_c('Select', {
    on: {
      "on-change": _vm.switchVersion
    },
    model: {
      value: (_vm.selectedVersionId),
      callback: function($$v) {
        _vm.selectedVersionId = $$v
      },
      expression: "selectedVersionId"
    }
  }, _vm._l((_vm.versions), function(v) {
    return _c('Option', {
      key: v.id,
      attrs: {
        "value": v.id
      }
    }, [_vm._v(_vm._s(v.versionNo) + " / " + _vm._s(_vm.statusLabel(v.status)))])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "技能"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.onFormSkillChange
    },
    model: {
      value: (_vm.form.skill),
      callback: function($$v) {
        _vm.$set(_vm.form, "skill", $$v)
      },
      expression: "form.skill"
    }
  }, [_c('Option', {
    attrs: {
      "value": "Listening"
    }
  }, [_vm._v("听力 Listening")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Reading"
    }
  }, [_vm._v("阅读 Reading")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "Writing"
    }
  }, [_vm._v("写作 Writing")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "级别"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 L1.0"
    },
    model: {
      value: (_vm.form.levelCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "levelCode", $$v)
      },
      expression: "form.levelCode"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题型"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": "",
      "placeholder": "检索已有题型"
    },
    on: {
      "on-change": _vm.onEditQuestionTypeChange
    },
    model: {
      value: (_vm.form.questionType),
      callback: function($$v) {
        _vm.$set(_vm.form, "questionType", $$v)
      },
      expression: "form.questionType"
    }
  }, _vm._l((_vm.editTypeOptions), function(t) {
    return _c('Option', {
      key: t.value,
      attrs: {
        "value": t.value
      }
    }, [_vm._v(_vm._s(t.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "场景"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.examScene),
      callback: function($$v) {
        _vm.$set(_vm.form, "examScene", $$v)
      },
      expression: "form.examScene"
    }
  }, [_c('Option', {
    attrs: {
      "value": "GENERAL"
    }
  }, [_vm._v("通用 GENERAL")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "PLACEMENT_ONLY"
    }
  }, [_vm._v("仅入门测 PLACEMENT_ONLY")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "SUMMATIVE_ONLY"
    }
  }, [_vm._v("仅阶段测 SUMMATIVE_ONLY")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "锚题"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.form.isAnchor),
      callback: function($$v) {
        _vm.$set(_vm.form, "isAnchor", $$v)
      },
      expression: "form.isAnchor"
    }
  }, [_c('Option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "交互类型"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 tap / speak / drag，可空"
    },
    model: {
      value: (_vm.form.interactionType),
      callback: function($$v) {
        _vm.$set(_vm.form, "interactionType", $$v)
      },
      expression: "form.interactionType"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "子技能英文"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": "",
      "placeholder": "选择题库已有子技能"
    },
    on: {
      "on-change": _vm.onSubSkillEnChange
    },
    model: {
      value: (_vm.form.subSkillEn),
      callback: function($$v) {
        _vm.$set(_vm.form, "subSkillEn", $$v)
      },
      expression: "form.subSkillEn"
    }
  }, _vm._l((_vm.subSkillEnOptions), function(t) {
    return _c('Option', {
      key: 'en-' + t.value,
      attrs: {
        "value": t.value
      }
    }, [_vm._v(_vm._s(t.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "子技能中文"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "transfer": "",
      "placeholder": "选择题库已有子技能"
    },
    on: {
      "on-change": _vm.onSubSkillCnChange
    },
    model: {
      value: (_vm.form.subSkillCn),
      callback: function($$v) {
        _vm.$set(_vm.form, "subSkillCn", $$v)
      },
      expression: "form.subSkillCn"
    }
  }, _vm._l((_vm.subSkillCnOptions), function(t) {
    return _c('Option', {
      key: 'cn-' + t.value,
      attrs: {
        "value": t.value
      }
    }, [_vm._v(_vm._s(t.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "次要技能JSON"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "雷达次要技能，可空。如 [\"vocab\",\"grammar\"]"
    },
    model: {
      value: (_vm.form.secondarySkillsJson),
      callback: function($$v) {
        _vm.$set(_vm.form, "secondarySkillsJson", $$v)
      },
      expression: "form.secondarySkillsJson"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "中文指令"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "给孩子看的中文指令"
    },
    model: {
      value: (_vm.form.instructionCn),
      callback: function($$v) {
        _vm.$set(_vm.form, "instructionCn", $$v)
      },
      expression: "form.instructionCn"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "英文指令"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "给孩子看的英文指令"
    },
    model: {
      value: (_vm.form.instructionEn),
      callback: function($$v) {
        _vm.$set(_vm.form, "instructionEn", $$v)
      },
      expression: "form.instructionEn"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "题干脚本"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "听力朗读脚本，听力题必填"
    },
    model: {
      value: (_vm.form.script),
      callback: function($$v) {
        _vm.$set(_vm.form, "script", $$v)
      },
      expression: "form.script"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "题干"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "题目正文"
    },
    model: {
      value: (_vm.form.stem),
      callback: function($$v) {
        _vm.$set(_vm.form, "stem", $$v)
      },
      expression: "form.stem"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题干音频"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "音频地址，可空"
    },
    model: {
      value: (_vm.form.stemAudio),
      callback: function($$v) {
        _vm.$set(_vm.form, "stemAudio", $$v)
      },
      expression: "form.stemAudio"
    }
  }), _vm._v(" "), _c('MexAssetPreview', {
    attrs: {
      "path": _vm.form.stemAudio,
      "skill": _vm.form.skill,
      "bank": "comp",
      "accept": "audio/*"
    },
    on: {
      "input": function($event) {
        _vm.form.stemAudio = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "题干图"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "图片地址，可空"
    },
    model: {
      value: (_vm.form.stemImage),
      callback: function($$v) {
        _vm.$set(_vm.form, "stemImage", $$v)
      },
      expression: "form.stemImage"
    }
  }), _vm._v(" "), _c('MexAssetPreview', {
    attrs: {
      "path": _vm.form.stemImage,
      "skill": _vm.form.skill,
      "bank": "comp",
      "accept": "image/*"
    },
    on: {
      "input": function($event) {
        _vm.form.stemImage = $event
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "选项"
    }
  }, [_c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("选择题填代号、文字和图片；拖字母/句子排序填可拖的字母或词块；完形、Gap Fill、判断、填空、四格写作选「无选项」。词形选词填空把词库写在选项文字里，不要填图片。")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "220px",
      "margin-bottom": "8px"
    },
    model: {
      value: (_vm.optionMode),
      callback: function($$v) {
        _vm.optionMode = $$v
      },
      expression: "optionMode"
    }
  }, [_c('Option', {
    attrs: {
      "value": "NONE"
    }
  }, [_vm._v("无选项")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "CHOICE"
    }
  }, [_vm._v("选择题")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "DRAG"
    }
  }, [_vm._v("拖拽字母/词块")])], 1), _vm._v(" "), (_vm.optionMode === 'CHOICE') ? _c('div', [_vm._l((_vm.choiceOptions), function(opt, idx) {
    return _c('div', {
      key: 'opt-' + idx,
      staticClass: "mex-dim-card",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticClass: "mex-opt-head"
    }, [_c('span', [_vm._v("选项 " + _vm._s(opt.code || (idx + 1)))]), _vm._v(" "), _c('Button', {
      attrs: {
        "size": "small",
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.removeChoice(idx)
        }
      }
    }, [_vm._v("删除")])], 1), _vm._v(" "), _c('Form', {
      attrs: {
        "show-message": false,
        "label-position": "top"
      }
    }, [_c('Row', {
      attrs: {
        "gutter": 12
      }
    }, [_c('i-col', {
      attrs: {
        "span": 6
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "代号"
      }
    }, [_c('Select', {
      model: {
        value: (opt.code),
        callback: function($$v) {
          _vm.$set(opt, "code", $$v)
        },
        expression: "opt.code"
      }
    }, _vm._l((_vm.optionCodes), function(c) {
      return _c('Option', {
        key: c,
        attrs: {
          "value": c
        }
      }, [_vm._v(_vm._s(c))])
    }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": 9
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "文字"
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "选项文案；纯图题可空"
      },
      model: {
        value: (opt.text),
        callback: function($$v) {
          _vm.$set(opt, "text", $$v)
        },
        expression: "opt.text"
      }
    })], 1)], 1), _vm._v(" "), (!_vm.isWordFormType) ? _c('i-col', {
      attrs: {
        "span": 9
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "图片"
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "选项图片地址，可空"
      },
      model: {
        value: (opt.image),
        callback: function($$v) {
          _vm.$set(opt, "image", $$v)
        },
        expression: "opt.image"
      }
    }), _vm._v(" "), _c('MexAssetPreview', {
      attrs: {
        "path": opt.image,
        "skill": _vm.form.skill,
        "bank": "comp",
        "accept": "image/*"
      },
      on: {
        "input": function($event) {
          opt.image = $event
        }
      }
    })], 1)], 1) : _vm._e()], 1)], 1)], 1)
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "dashed",
      "long": ""
    },
    on: {
      "click": _vm.addChoice
    }
  }, [_vm._v("添加选项")])], 2) : _vm._e(), _vm._v(" "), (_vm.optionMode === 'DRAG') ? _c('div', {
    staticClass: "mex-dim-card"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 8
    }
  }, _vm._l((_vm.dragTokens), function(tok, idx) {
    return _c('i-col', {
      key: 'tok-' + idx,
      attrs: {
        "span": 6
      }
    }, [_c('Form-item', {
      attrs: {
        "label": '第 ' + (idx + 1) + ' 块'
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "如 l 或 ball"
      },
      model: {
        value: (tok.value),
        callback: function($$v) {
          _vm.$set(tok, "value", $$v)
        },
        expression: "tok.value"
      }
    }, [_c('Button', {
      attrs: {
        "slot": "append"
      },
      on: {
        "click": function($event) {
          return _vm.removeDrag(idx)
        }
      },
      slot: "append"
    }, [_vm._v("删")])], 1)], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "dashed",
      "long": ""
    },
    on: {
      "click": _vm.addDrag
    }
  }, [_vm._v("添加一块")])], 1) : _vm._e()], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "填空"
    }
  }, [_c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("完形、Gap Fill、听读同篇多问：每一问是选项。听力 Fill in the Blanks：同一段音频多空，每空填短语。写作词形：短文留空，上面选项是词库，下面每空填变化后的词形。")]), _vm._v(" "), _vm._l((_vm.blanks), function(blank, idx) {
    return _c('div', {
      key: 'blank-' + idx,
      staticClass: "mex-dim-card",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticClass: "mex-opt-head"
    }, [_c('span', [_vm._v("第 " + _vm._s(blank.no || (idx + 1)) + " 空")]), _vm._v(" "), _c('Button', {
      attrs: {
        "size": "small",
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.removeBlank(idx)
        }
      }
    }, [_vm._v("删除")])], 1), _vm._v(" "), _c('Form', {
      attrs: {
        "show-message": false,
        "label-position": "top"
      }
    }, [_c('Row', {
      attrs: {
        "gutter": 12
      }
    }, [_c('i-col', {
      attrs: {
        "span": 6
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "空号"
      }
    }, [_c('Input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "min": 1,
        "max": 50,
        "placeholder": "空号，如 1"
      },
      model: {
        value: (blank.no),
        callback: function($$v) {
          _vm.$set(blank, "no", $$v)
        },
        expression: "blank.no"
      }
    })], 1)], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": 9
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "提示"
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "题干里这一空的提示，可空"
      },
      model: {
        value: (blank.prompt),
        callback: function($$v) {
          _vm.$set(blank, "prompt", $$v)
        },
        expression: "blank.prompt"
      }
    })], 1)], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "span": 9
      }
    }, [_c('Form-item', {
      attrs: {
        "label": "答案"
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": _vm.isFillBlanksType ? '这一空的短语答案，如 Rock climbing and kayaking' : '这一空的标准答案，如 hiking'
      },
      model: {
        value: (blank.answer),
        callback: function($$v) {
          _vm.$set(blank, "answer", $$v)
        },
        expression: "blank.answer"
      }
    })], 1)], 1)], 1), _vm._v(" "), (_vm.isBlankChoiceType) ? _c('Form-item', {
      attrs: {
        "label": "本空选项"
      }
    }, _vm._l(((blank.options || [])), function(opt, oi) {
      return _c('div', {
        key: 'bopt-' + idx + '-' + oi,
        staticStyle: {
          "margin-bottom": "6px"
        }
      }, [_c('Row', {
        attrs: {
          "gutter": 8
        }
      }, [_c('i-col', {
        attrs: {
          "span": 6
        }
      }, [_c('Input', {
        attrs: {
          "placeholder": "代号 A"
        },
        model: {
          value: (opt.code),
          callback: function($$v) {
            _vm.$set(opt, "code", $$v)
          },
          expression: "opt.code"
        }
      })], 1), _vm._v(" "), _c('i-col', {
        attrs: {
          "span": 18
        }
      }, [_c('Input', {
        attrs: {
          "placeholder": "选项文字"
        },
        model: {
          value: (opt.text),
          callback: function($$v) {
            _vm.$set(opt, "text", $$v)
          },
          expression: "opt.text"
        }
      })], 1)], 1)], 1)
    }), 0) : _vm._e(), _vm._v(" "), (_vm.isClozeType || _vm.isFillBlanksType || _vm.isBlankChoiceType || _vm.isWordFormType) ? _c('Form-item', {
      attrs: {
        "label": "本空解析"
      }
    }, [_c('Input', {
      attrs: {
        "type": "textarea",
        "rows": 2,
        "placeholder": _vm.isFillBlanksType ? '这一空的短语解析，可空' : '这一问为什么选这个答案'
      },
      model: {
        value: (blank.explanation),
        callback: function($$v) {
          _vm.$set(blank, "explanation", $$v)
        },
        expression: "blank.explanation"
      }
    })], 1) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "dashed",
      "long": ""
    },
    on: {
      "click": _vm.addBlank
    }
  }, [_vm._v("添加一空")])], 2), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "标准答案"
    }
  }, [_c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v(_vm._s(_vm.answerHint))]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": _vm.answerPlaceholder
    },
    model: {
      value: (_vm.form.answerKey),
      callback: function($$v) {
        _vm.$set(_vm.form, "answerKey", $$v)
      },
      expression: "form.answerKey"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "完整参考作答"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "完整示范答案，可空"
    },
    model: {
      value: (_vm.form.referenceAnswerFull),
      callback: function($$v) {
        _vm.$set(_vm.form, "referenceAnswerFull", $$v)
      },
      expression: "form.referenceAnswerFull"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "满分"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "听1-3，读1-5，写客观1-2、主观5-10"
    },
    model: {
      value: (_vm.form.fullScore),
      callback: function($$v) {
        _vm.$set(_vm.form, "fullScore", $$v)
      },
      expression: "form.fullScore"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "星级"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "1-5 星"
    },
    model: {
      value: (_vm.form.difficultyLevel),
      callback: function($$v) {
        _vm.$set(_vm.form, "difficultyLevel", $$v)
      },
      expression: "form.difficultyLevel"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "抽题权重"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "现稿多为 0.5"
    },
    model: {
      value: (_vm.form.adaptiveWeight),
      callback: function($$v) {
        _vm.$set(_vm.form, "adaptiveWeight", $$v)
      },
      expression: "form.adaptiveWeight"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "听力播放次数"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "听力默认 2，其他可空"
    },
    model: {
      value: (_vm.form.audioPlayLimit),
      callback: function($$v) {
        _vm.$set(_vm.form, "audioPlayLimit", $$v)
      },
      expression: "form.audioPlayLimit"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "评分维度"
    }
  }, [_c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("听读客观题填正确性。看图写句、四格故事、邮件/回信用内容、逻辑、语法、词汇。建议合计 100。")]), _vm._v(" "), _c('div', {
    staticClass: "mex-dim-card"
  }, [_c('Form', {
    attrs: {
      "show-message": false,
      "label-position": "top"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, _vm._l((_vm.dimensions), function(d) {
    return _c('i-col', {
      key: d.key,
      attrs: {
        "span": _vm.dimensions.length > 1 ? 6 : 8
      }
    }, [_c('Form-item', {
      attrs: {
        "label": _vm.dimLabel(d.key)
      }
    }, [_c('Input-number', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "min": 0,
        "max": 100,
        "placeholder": "百分数，如 100"
      },
      model: {
        value: (d.weight),
        callback: function($$v) {
          _vm.$set(d, "weight", $$v)
        },
        expression: "d.weight"
      }
    })], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("当前合计 " + _vm._s(_vm.dimSum))])], 1)]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "评分细则"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "人工/规则评分细则，可空"
    },
    model: {
      value: (_vm.form.scoringRubric),
      callback: function($$v) {
        _vm.$set(_vm.form, "scoringRubric", $$v)
      },
      expression: "form.scoringRubric"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "AI基准"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "AI 评分基准；客观题可空，写作主观建议填"
    },
    model: {
      value: (_vm.form.aiBenchmark),
      callback: function($$v) {
        _vm.$set(_vm.form, "aiBenchmark", $$v)
      },
      expression: "form.aiBenchmark"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "解析"
    }
  }, [(_vm.isClozeType || _vm.isFillBlanksType || _vm.isBlankChoiceType || _vm.isWordFormType) ? _c('p', {
    staticClass: "mex-dim-hint"
  }, [_vm._v("各空解析写在上面每一空里。这里保存时会按空号拼成备份文案。")]) : _vm._e(), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": (_vm.isClozeType || _vm.isFillBlanksType || _vm.isBlankChoiceType || _vm.isWordFormType) ? '可由每空解析自动拼接' : '解析文案，可空'
    },
    model: {
      value: (_vm.form.explanation),
      callback: function($$v) {
        _vm.$set(_vm.form, "explanation", $$v)
      },
      expression: "form.explanation"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "考点"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "考查点，可空"
    },
    model: {
      value: (_vm.form.examPoint),
      callback: function($$v) {
        _vm.$set(_vm.form, "examPoint", $$v)
      },
      expression: "form.examPoint"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "内部备注，可空"
    },
    model: {
      value: (_vm.form.remark),
      callback: function($$v) {
        _vm.$set(_vm.form, "remark", $$v)
      },
      expression: "form.remark"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "常见错误"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "常见错误说明，可空"
    },
    model: {
      value: (_vm.form.commonMistakes),
      callback: function($$v) {
        _vm.$set(_vm.form, "commonMistakes", $$v)
      },
      expression: "form.commonMistakes"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "知识点"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "知识点路径，可空"
    },
    model: {
      value: (_vm.form.knowledgePointHierarchy),
      callback: function($$v) {
        _vm.$set(_vm.form, "knowledgePointHierarchy", $$v)
      },
      expression: "form.knowledgePointHierarchy"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "篇章ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "同篇阅读共用，如 P-L3-001"
    },
    model: {
      value: (_vm.form.passageId),
      callback: function($$v) {
        _vm.$set(_vm.form, "passageId", $$v)
      },
      expression: "form.passageId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "填空组ID"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "同组填空共用，可空"
    },
    model: {
      value: (_vm.form.groupId),
      callback: function($$v) {
        _vm.$set(_vm.form, "groupId", $$v)
      },
      expression: "form.groupId"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "篇章图"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "篇章图片地址，可空"
    },
    model: {
      value: (_vm.form.passageImage),
      callback: function($$v) {
        _vm.$set(_vm.form, "passageImage", $$v)
      },
      expression: "form.passageImage"
    }
  }), _vm._v(" "), _c('MexAssetPreview', {
    attrs: {
      "path": _vm.form.passageImage,
      "skill": _vm.form.skill,
      "bank": "comp",
      "accept": "image/*"
    },
    on: {
      "input": function($event) {
        _vm.form.passageImage = $event
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "篇章正文"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "阅读篇章正文，可空"
    },
    model: {
      value: (_vm.form.passageText),
      callback: function($$v) {
        _vm.$set(_vm.form, "passageText", $$v)
      },
      expression: "form.passageText"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "字数要求"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 3-4句话，20-40词；客观拼写可填「无」"
    },
    model: {
      value: (_vm.form.wordCountRequirement),
      callback: function($$v) {
        _vm.$set(_vm.form, "wordCountRequirement", $$v)
      },
      expression: "form.wordCountRequirement"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "写作得分要点"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "写作主观得分要点，可空"
    },
    model: {
      value: (_vm.form.scoringPoints),
      callback: function($$v) {
        _vm.$set(_vm.form, "scoringPoints", $$v)
      },
      expression: "form.scoringPoints"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "写作参考范文"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "写作参考范文，可空"
    },
    model: {
      value: (_vm.form.scoringReference),
      callback: function($$v) {
        _vm.$set(_vm.form, "scoringReference", $$v)
      },
      expression: "form.scoringReference"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "配图提示词"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "配图生成提示词，可空"
    },
    model: {
      value: (_vm.form.imageGenerationPrompt),
      callback: function($$v) {
        _vm.$set(_vm.form, "imageGenerationPrompt", $$v)
      },
      expression: "form.imageGenerationPrompt"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "手写范文图"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "手写范文图地址，可空"
    },
    model: {
      value: (_vm.form.answerSampleImage),
      callback: function($$v) {
        _vm.$set(_vm.form, "answerSampleImage", $$v)
      },
      expression: "form.answerSampleImage"
    }
  }), _vm._v(" "), _c('MexAssetPreview', {
    attrs: {
      "path": _vm.form.answerSampleImage,
      "skill": _vm.form.skill,
      "bank": "comp",
      "accept": "image/*"
    },
    on: {
      "input": function($event) {
        _vm.form.answerSampleImage = $event
      }
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "能力编码"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 LIS-01 / REA-01 / WRI-01"
    },
    model: {
      value: (_vm.form.abilityDimensionCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "abilityDimensionCode", $$v)
      },
      expression: "form.abilityDimensionCode"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "能力档"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "内部能力档，可空"
    },
    model: {
      value: (_vm.form.scoreMappingLevel),
      callback: function($$v) {
        _vm.$set(_vm.form, "scoreMappingLevel", $$v)
      },
      expression: "form.scoreMappingLevel"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程单元"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "对应课程单元，可空"
    },
    model: {
      value: (_vm.form.courseUnitMapping),
      callback: function($$v) {
        _vm.$set(_vm.form, "courseUnitMapping", $$v)
      },
      expression: "form.courseUnitMapping"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "能力描述"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "报告用的能力描述，可空"
    },
    model: {
      value: (_vm.form.abilityDescription),
      callback: function($$v) {
        _vm.$set(_vm.form, "abilityDescription", $$v)
      },
      expression: "form.abilityDescription"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "全国均分"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 72.5，可空"
    },
    model: {
      value: (_vm.form.benchmarkNationalAvg),
      callback: function($$v) {
        _vm.$set(_vm.form, "benchmarkNationalAvg", $$v)
      },
      expression: "form.benchmarkNationalAvg"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "同城优秀均分"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 85，可空"
    },
    model: {
      value: (_vm.form.benchmarkCityExcellentAvg),
      callback: function($$v) {
        _vm.$set(_vm.form, "benchmarkCityExcellentAvg", $$v)
      },
      expression: "form.benchmarkCityExcellentAvg"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "提升建议"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 2,
      "placeholder": "报告提升建议，可空"
    },
    model: {
      value: (_vm.form.improvementSuggestion),
      callback: function($$v) {
        _vm.$set(_vm.form, "improvementSuggestion", $$v)
      },
      expression: "form.improvementSuggestion"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "练习推荐"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "推荐练习，可空"
    },
    model: {
      value: (_vm.form.recommendedPractice),
      callback: function($$v) {
        _vm.$set(_vm.form, "recommendedPractice", $$v)
      },
      expression: "form.recommendedPractice"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "前置知识"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "前置知识，可空"
    },
    model: {
      value: (_vm.form.prerequisiteKnowledge),
      callback: function($$v) {
        _vm.$set(_vm.form, "prerequisiteKnowledge", $$v)
      },
      expression: "form.prerequisiteKnowledge"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "掌握周期"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "如 1-2周，可空"
    },
    model: {
      value: (_vm.form.learningCycle),
      callback: function($$v) {
        _vm.$set(_vm.form, "learningCycle", $$v)
      },
      expression: "form.learningCycle"
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "IRT b"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "难度 b，可空"
    },
    model: {
      value: (_vm.form.irtB),
      callback: function($$v) {
        _vm.$set(_vm.form, "irtB", $$v)
      },
      expression: "form.irtB"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "IRT a"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "区分度 a，可空"
    },
    model: {
      value: (_vm.form.irtA),
      callback: function($$v) {
        _vm.$set(_vm.form, "irtA", $$v)
      },
      expression: "form.irtA"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "IRT c"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "猜测 c，可空"
    },
    model: {
      value: (_vm.form.irtC),
      callback: function($$v) {
        _vm.$set(_vm.form, "irtC", $$v)
      },
      expression: "form.irtC"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "失误率"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "儿童失误率，可空"
    },
    model: {
      value: (_vm.form.childSlip),
      callback: function($$v) {
        _vm.$set(_vm.form, "childSlip", $$v)
      },
      expression: "form.childSlip"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": function($event) {
        _vm.editVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveEdit
    }
  }, [_vm._v("保存")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27243571","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mex/MexCompQuestionList.vue
// module id = 1706
// module chunks = 8